export * from './objekt-post-request.interface';
export * from './objekt-post-response.interface';
export * from './objekt-post.shapes';
